import miniCodeComponent from './miniCode.vue';
let $vm;
export default {
  install(Vue, options={}) {
    if (!$vm) {
      const LoadingPlugin = Vue.extend(miniCodeComponent);
      $vm = new LoadingPlugin({});
      document.body.appendChild($vm.$mount().$el);
    }

    let minicode = {
      show(pageCode) {
        $vm.openApplets(pageCode)
      }
    }
    if (!Vue.$minicode) {
      Vue.$minicode = minicode;
    }
    Vue.mixin({
      created() {
        this.$minicode = Vue.$minicode;
      }
    })
  }
}



